import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useCreateJobApplicationMutation, useGetAllJobsForFilterQuery } from "store/features/jobs/jobApplicationApi";
import { toast } from "sonner";

const AddJobApplicationModal = ({ isOpen, toggle, onApplicationCreated }) => {
  const [createJobApplication, { isLoading }] = useCreateJobApplicationMutation();
  const { data: jobs = [] } = useGetAllJobsForFilterQuery();
  const [cvFile, setCvFile] = useState(null);

  const jobOptions = [
    { value: "", label: "General Application" },
    ...jobs.map(job => ({
      value: String(job.id),
      label: `${job.title} (${job.company || 'QwikIT'})`,
    })),
  ];

  const handleSubmit = async (data) => {
    try {
      const selectedJob = jobs.find(j => String(j.id) === String(data.jobid));
      const formData = new FormData();
      
      formData.append("applicantname", data.applicantname || "");
      formData.append("applicantemail", data.applicantemail || "");
      formData.append("contactNumber", data.contactNumber || "");
      formData.append("applicantexperience", data.applicantexperience || "0");
      if (data.jobid) {
        formData.append("jobid", data.jobid);
      }
      formData.append("title", selectedJob ? selectedJob.title : (data.title || "General Application"));
      formData.append("currentSalary", data.currentSalary || "");
      formData.append("expectedSalary", data.expectedSalary || "");
      formData.append("noticePeriod", data.noticePeriod || "");
      formData.append("country", data.country || "Bangladesh");
      const todayDate = new Date().toISOString().split('T')[0];
      formData.append("date", todayDate);
      formData.append("applystatus", true);
      formData.append("selectionstatus", false);

      if (cvFile) {
        formData.append("cv", cvFile);
      }

      await createJobApplication(formData).unwrap();
      toast.success("Job application created successfully!");
      if (onApplicationCreated) onApplicationCreated();
      handleClose();
    } catch (error) {
      console.error("Error creating application:", error);
      const errMsg = error?.data?.detail || error?.data?.message || "Failed to create job application";
      toast.error(errMsg);
    }
  };

  const handleClose = () => {
    setCvFile(null);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="lg">
      <ModalHeader toggle={handleClose}>Add Job Application (Manual)</ModalHeader>
      <QwikForm onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="jobid"
                  label="Select Job"
                  options={jobOptions}
                  placeholder="Select Job"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="applicantname"
                  label="Applicant Name *"
                  placeholder="Enter full name"
                  type="text"
                  required
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="applicantemail"
                  label="Applicant Email *"
                  placeholder="Enter email address"
                  type="email"
                  required
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="contactNumber"
                  label="Contact Phone *"
                  placeholder="Enter phone number"
                  type="text"
                  required
                />
              </div>
            </Col>

            <Col lg={4}>
              <div className="mb-3">
                <QwikInput
                  name="applicantexperience"
                  label="Experience (Years)"
                  placeholder="e.g. 2"
                  type="number"
                />
              </div>
            </Col>

            <Col lg={4}>
              <div className="mb-3">
                <QwikInput
                  name="currentSalary"
                  label="Current Salary"
                  placeholder="e.g. 35000"
                  type="text"
                />
              </div>
            </Col>

            <Col lg={4}>
              <div className="mb-3">
                <QwikInput
                  name="expectedSalary"
                  label="Expected Salary"
                  placeholder="e.g. 50000"
                  type="text"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="noticePeriod"
                  label="Notice Period"
                  placeholder="e.g. 30 days"
                  type="text"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="country"
                  label="Country"
                  placeholder="e.g. Bangladesh"
                  type="text"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Resume / CV File (PDF, DOCX)</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => setCvFile(e.target.files[0])}
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Add Application"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default AddJobApplicationModal;
